export default __webpack_public_path__ + "static/friend_03-03554d776e16743ec4053610551f784a.png";